export default {
      id: "complete-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#complete",
      toString: function () {
        return this.url;
      }
    }